import AppLayout from '../layouts/AppLayout'

export const users = {
  path: '/users',
  component: AppLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '',
      name: 'users.index',
      component: () =>
        import(
          /* webpackChunkName: "menu.index" */ '@/views/administracion/usuario.vue'
        ),
      meta: {
        title: 'Usuarios',
        breadcrumb: [
          {
            text: 'dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Usuarios'
          }
        ]
      }
    },
    {
      path: 'crear',
      name: 'users.create',
      component: () =>
        import(
          /* webpackChunkName: "users.create" */ '@/views/administracion/usuario/create.vue'
        ),
      meta: {
        title: 'Crear',
        breadcrumb: [
          {
            text: 'dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Usuarios',
            to: { name: 'users.index' },
            active: true
          },
          {
            text: 'Crear'
          }
        ]
      }
    },
    {
      path: 'editar/:id',
      name: 'users.edit',
      component: () =>
        import(
          /* webpackChunkName: "users.edit" */ '@/views/administracion/usuario/edit.vue'
        ),
      meta: {
        title: 'Editar',
        breadcrumb: [
          {
            text: 'dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Usuarios',
            to: { name: 'users.index' },
            active: true
          },
          {
            text: 'Editar'
          }
        ]
      }
    }
  ]
}
